<template>
  <router-view />
</template>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

/* 让 MessageBox 文本支持 \n 换行 */
.el-message-box__message {
  white-space: pre-line !important; /* 核心：识别 \n 并自动换行，同时合并多余空格 */
}
</style>
